<template>
  <div>
    <div id="experience-table">
      <table class="table table-hover ui-table mb-4 mt-2">
        <thead>
          <tr>
            <th>
              {{
                $t(
                  'school.academic.operation.profile_mgt.teacher_profile.date_from'
                )
              }}
            </th>
            <th>
              {{
                $t(
                  'school.academic.operation.profile_mgt.teacher_profile.date_to'
                )
              }}
            </th>
            <th>
              {{
                $t(
                  'school.academic.operation.profile_mgt.teacher_profile.institution'
                )
              }}
            </th>
            <th>
              {{
                $t(
                  'school.academic.operation.profile_mgt.teacher_profile.main_program'
                )
              }}
            </th>
            <th>
              {{
                $t(
                  'school.academic.operation.profile_mgt.teacher_profile.sub_program'
                )
              }}
            </th>
            <th>
              {{
                $t(
                  'school.academic.operation.profile_mgt.teacher_profile.subject'
                )
              }}
            </th>
            <th>
              {{
                $t(
                  'school.academic.operation.profile_mgt.teacher_profile.level'
                )
              }}
            </th>
            <th style="width: 3%" class="text-center">
              <a href="#" @click.prevent="addNewRow">
                <i class="fa fa-plus"></i>
              </a>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(experience, index) in teacher_experience_list"
            :key="index"
          >
            <td style="width: 12%">
              <ts-date-picker-input
                v-model="experience.from_date"
              ></ts-date-picker-input>
              <div
                class="validate"
                v-if="
                  errors.has('teacher_experience_list.' + index + '.from_date')
                "
              >
                {{
                  errors.first(
                    'teacher_experience_list.' + index + '.from_date'
                  )
                }}
              </div>
            </td>
            <td style="width: 12%">
              <ts-date-picker-input
                v-model="experience.to_date"
              ></ts-date-picker-input>
              <div
                class="validate"
                v-if="
                  errors.has('teacher_experience_list.' + index + '.to_date')
                "
              >
                {{
                  errors.first('teacher_experience_list.' + index + '.to_date')
                }}
              </div>
            </td>
            <td>
              <input
                type="text"
                v-model.trim="experience.institution"
                class="form-control only-border-bottom"
                :class="{
                  'is-invalid': errors.has(
                    'teacher_experience_list.' + index + '.institution'
                  ),
                }"
              />
              <div
                class="invalid-feedback"
                v-if="
                  errors.has(
                    'teacher_experience_list.' + index + '.institution'
                  )
                "
              >
                {{
                  errors.first(
                    'teacher_experience_list.' + index + '.institution'
                  )
                }}
              </div>
            </td>
            <td>
              <select
                class="form-control only-border-bottom"
                :class="{
                  'is-invalid': errors.has(
                    'teacher_experience_list.' + index + '.acp_id'
                  ),
                }"
                v-model="experience.acp_id"
                @change="onMainProgramChange(experience)"
              >
                <option value="">{{ $t('select') }}</option>
                <option
                  v-for="(main_program, index) in main_programs"
                  :key="index"
                  :value="main_program.acp_id"
                >
                  {{ main_program.acp_name_foreign }}
                </option>
              </select>
              <div
                class="invalid-feedback"
                v-if="
                  errors.has('teacher_experience_list.' + index + '.acp_id')
                "
              >
                {{
                  errors.first('teacher_experience_list.' + index + '.acp_id')
                }}
              </div>
            </td>
            <td>
              <select
                class="form-control only-border-bottom"
                :class="{
                  'is-invalid': errors.has(
                    'teacher_experience_list.' + index + '.acps_id'
                  ),
                }"
                v-model="experience.acps_id"
                @change="onSubProgramChange(experience)"
              >
                <option value="">{{ $t('select') }}</option>
                <option
                  v-for="(sub, index) in getSubPrograms(experience.acp_id)"
                  :key="index"
                  :value="sub.acps_id"
                >
                  {{ sub.acps_name_foreign }}
                </option>
              </select>
              <div
                class="invalid-feedback"
                v-if="
                  errors.has('teacher_experience_list.' + index + '.acps_id')
                "
              >
                {{
                  errors.first('teacher_experience_list.' + index + '.acps_id')
                }}
              </div>
            </td>
            <td>
              <select
                class="form-control only-border-bottom"
                :class="{
                  'is-invalid': errors.has(
                    'teacher_experience_list.' + index + '.subject_id'
                  ),
                }"
                v-model="experience.subject_id"
              >
                <option value="">{{ $t('select') }}</option>
                <option
                  v-for="(subjectItem, index) in getSubject(experience.acps_id)"
                  :key="index"
                  :value="subjectItem.subject_id"
                >
                  {{ subjectItem.subject_name_foreign }}
                </option>
              </select>
              <div
                class="invalid-feedback"
                v-if="
                  errors.has('teacher_experience_list.' + index + '.subject_id')
                "
              >
                {{
                  errors.first(
                    'teacher_experience_list.' + index + '.subject_id'
                  )
                }}
              </div>
            </td>
            <td>
              <select
                class="form-control only-border-bottom"
                :class="{
                  'is-invalid': errors.has(
                    'teacher_experience_list.' + index + '.level_id'
                  ),
                }"
                v-model="experience.level_id"
              >
                <option value="">{{ $t('select') }}</option>
                <option value="1">{{ $t('teacherprofile.level1') }}</option>
                <option value="2">{{ $t('teacherprofile.level2') }}</option>
                <option value="3">{{ $t('teacherprofile.level3') }}</option>
              </select>
              <div
                class="invalid-feedback"
                v-if="
                  errors.has('teacher_experience_list.' + index + '.level_id')
                "
              >
                {{
                  errors.first('teacher_experience_list.' + index + '.level_id')
                }}
              </div>
            </td>
            <td>
              <a
                href="#"
                class="text-danger"
                @click.prevent="removeRow(experience)"
              >
                <i class="fa fa-trash mt-2"></i>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'experience',
  props: ['value', 'validate'],
  data() {
    return {
      teacher_experience_list: [],
      newRow: {
        institution: '',
        subject_id: '',
        level_id: '',
        from_date: '',
        to_date: '',
        acp_id: '',
        acps_id: '',
      },
      errors: new Errors(),
    }
  },
  computed: {
    ...mapState('teacherProfile', ['main_programs', 'edit_data']),
    ...mapGetters('teacherProfile', ['getSubPrograms', 'getSubject']),
  },
  created() {
    this.teacher_experience_list = this.value
  },
  methods: {
    addNewRow() {
      this.teacher_experience_list.push(Object.assign({}, this.newRow))
    },
    removeRow(row) {
      this.teacher_experience_list.splice(
        this.teacher_experience_list.indexOf(row),
        1
      )
    },
    onMainProgramChange(experience) {
      if (!experience.acp_id) {
        experience.acps_id = ''
        experience.subject_id = ''
        experience.level_id = ''
        return
      }
      this.$store
        .dispatch('teacherProfile/subProgram', experience.acp_id)
        .then((response) => {})
        .catch((error) => {
          this.$toasted.error(error.message)
        })
    },
    onSubProgramChange(experience) {
      if (!experience.acps_id) {
        experience.subject_id = ''
        experience.level_id = ''
        return
      }
      this.$store
        .dispatch('teacherProfile/subject', experience.acps_id)
        .then((response) => {})
        .catch((error) => {
          this.$toasted.error(error.message)
        })
    },
  },
  watch: {
    value: {
      handler() {
        this.teacher_experience_list = this.value
      },
    },
    validate: {
      handler() {
        this.errors = new Errors(this.validate.errors)
      },
      deep: true,
    },
    edit_data: {
      handler() {
        if (!_.isEmpty(this.edit_data)) {
          this.edit_data.experiences.map(async (el) => {
            await this.onMainProgramChange(el)
            await this.onSubProgramChange(el)
          })
        }
      },
      deep: true,
      immediate: true,
    },
  },
}
</script>

<style lang="css" scoped>
#experience-table {
  max-height: 20vh;
  overflow-y: scroll;
  overflow-x: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
#experience-table::-webkit-scrollbar {
  width: 3px; /* Remove scrollbar space */
  background: transparent; /* Optional: just make scrollbar invisible */
}
/* Optional: show position indicator in red */
#experience-table::-webkit-scrollbar-thumb {
  background: rgb(194, 194, 194);
}
.table > thead > tr > th {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 999;
}
.table > tbody > tr > td {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
  border: none !important;
}
.only-border-bottom {
  border-top: none;
  border-left: none;
  border-right: none;
}
</style>
